import { useSelector } from "react-redux";
import swal from 'sweetalert';
import { toast } from "react-toastify";
import { addMember } from "../../http";
import { useDispatch } from "react-redux";
import { setFreeEmployees, setTeamMembers } from "../../store/user-slice";
import { updateEmployeeCount } from "../../store/team-slice";

const RowAddMember = ({index,data}) =>
{

  const {team} = useSelector(state=>state.teamSlice);
  const {freeEmployees,teamMembers} = useSelector(state=>state.userSlice);
  const dispatch = useDispatch();

  const add = async () => {
    try {
        // Call API to add the member
        const response = await addMember({ userId: data.id, teamId: team.id });
        if (response.data && response.data.success) {
            // Success: Show toast and update the store
            toast.success(response.data.message);
            removeMemberFromStore(data.id); // Function to update frontend store
        } else {
            // Handle unsuccessful responses
            const errorMessage = response.data && response.data.message
                ? response.data.message
                : "Failed to add member.";
            toast.error(errorMessage);
        }
    } catch (error) {
        // Handle network or unexpected errors
        if (error.response && error.response.data) {
            // Server returned an error response
            console.error("Server Error:", error.response.data);
            toast.error(error.response.data.message || "An error occurred while adding the member.");
        } else {
            // No response or unexpected error
            console.error("Unexpected Error:", error);
            toast.error("An unexpected error occurred. Please try again.");
        }
    }
};



  const removeMemberFromStore = (id) =>
  {
      dispatch(setFreeEmployees(freeEmployees.filter(data=> data.id!==id)));
      dispatch(setTeamMembers([...teamMembers,data]));
      dispatch(updateEmployeeCount('INCREMENT'));
  }

    const showDialog = () =>
    {  swal({
        title: "Are you sure?",
        text: `You want to add!\n${data.name} \ninto this team`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((yes) => {
        if (yes)
          add();
      });
    }

    return(
        <tr>
            <td>{index}</td>
            <td><figure className="avatar"> <img src={data.image} alt={data.name}/> </figure></td>
            <td>{data.name}</td>
            <td>{data.email}</td>
            <td>{data.mobile}</td>
            <td><div className={`badge ${data.status==='Active' ? 'badge-primary' :'badge-danger'}`}>{data.status}</div></td>
            <td><button className='btn btn-success' onClick={showDialog}><i className="fas fa-plus"></i></button></td>
        </tr>
    );
}

export default RowAddMember;